import { render, staticRenderFns } from "./commentsContent.vue?vue&type=template&id=1af689ae&scoped=true&"
import script from "./commentsContent.vue?vue&type=script&lang=js&"
export * from "./commentsContent.vue?vue&type=script&lang=js&"
import style0 from "./commentsContent.vue?vue&type=style&index=0&id=1af689ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af689ae",
  null
  
)

export default component.exports